import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a view for filtering transactions by player deposit reports.
 */
export default class FilterTransactionsByPlayerDepositReports extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            id: 'a1',
            margin: 5,
            rows: [
                {
                    responsive: 'a1',
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            id: 'Datepicker', // Date range picker
                            name: 'Datepicker',
                            view: 'text',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for date range
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            id: 'Date', // Single date picker
                            name: 'Date',
                            view: 'datepicker',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            id: 'PlayerId', // Player ID input
                            name: 'PlayerId',
                            view: 'text',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Jugador'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'richselect', // Dropdown for document type selection
                            name: 'DocumentType',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Tipo Documento'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: '1', value: _('DNI') },
                                { id: '2', value: _('Cédula de extranjería') },
                                { id: '3', value: _('Pasaporte') },
                            ],
                        },
                        {
                            id: 'DocumentNumber', // Document number input
                            name: 'DocumentNumber',
                            view: 'text',
                            type: 'number',
                            minWidth: 250,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Numero del documento'),
                            labelPosition: 'top',
                            placeholder: _('Numero'),
                        },
                    ],
                },
                {
                    responsive: 'a1',
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            id: 'PlayerName', // Player name input
                            name: 'PlayerName',
                            view: 'text',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Nombre del jugador'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {},
                        {},
                        {},
                    ],
                },
            ],
        };
        /**
         * Configuration object for the upper section of the filter form.
         * Contains a container with a margin and a single column layout.
         */
        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10, // Margin around the component
                    cols: [left], // Columns in the row
                },
            ],
        };

        /**
         * Configuration object for the buttons in the filter form.
         * Contains buttons for clearing the form and submitting the form.
         */
        const buttons = {
            cols: [
                {},
                {
                    view: 'button', // Button component
                    value: _('Limpiar'), // Localized label for the button
                    width: screen == 'small' ? 0 : 100, // Width of the button
                    minWidth: 200, // Minimum width of the button
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country select value
                        $$('Datepicker').setValue(''); // Reset date picker value
                    },
                },
                {
                    id: 'consultDesk', // Unique identifier for the button
                    view: 'button', // Button component
                    value: _('Consultar'), // Localized label for the button
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Button type
                    width: screen == 'small' ? 0 : 100, // Width of the button
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country select value
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove date picker field if not needed
                            }
                        }
                        this.app.callEvent('transactionsByPlayerDeposit:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to the top
                    },
                },
            ],
        };

        /**
         * Configuration object for the secondary buttons in the filter form.
         * Contains buttons for clearing the form and submitting the form.
         */
        const buttons2 = {
            padding: 10, // Padding around the component
            cols: [
                {
                    view: 'button', // Button component
                    value: _('Limpiar'), // Localized label for the button
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect); // Reset country select value
                        $$('Datepicker').setValue(''); // Reset date picker value
                    },
                },
                {
                    id: 'consultDesk', // Unique identifier for the button
                    view: 'button', // Button component
                    value: _('Consultar'), // Localized label for the button
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Button type
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country select value
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove date picker field if not needed
                            }
                        }
                        this.app.callEvent('transactionsByPlayerDeposit:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        /**
         * Configuration object for the accordion section of the filter form.
         * Contains an accordion with a filter section.
         */
        const accordion_section2 = {
            type: 'wide', // Accordion type
            rows: [
                {
                    multi: true, // Allow multiple sections to be open
                    view: 'accordion', // Accordion component
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initially collapsed
                    type: 'clean', // Clean type
                    rows: [
                        {
                            id: 'b5', // Unique identifier for the accordion section
                            header: _('Filtros'), // Localized header for the section
                            body: {
                                padding: 10, // Padding around the component
                                rows: [upper_section, buttons], // Rows in the accordion section
                            },
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the scrollable accordion section of the filter form.
         * Contains a scrollable view with the upper section.
         */
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view component
            scroll: 'xy', // Enable both horizontal and vertical scrolling
            body: {
                padding: 10, // Padding around the component
                rows: [upper_section], // Rows in the scrollable view
            },
        };

        /**
         * Configuration object for the filter popup window.
         * Contains a window with a form for filtering transactions.
         */
        const filterPopup = webix.ui({
            view: 'window', // Window component
            move: true, // Allow the window to be moved
            id: 'filterPopup', // Unique identifier for the window
            fullscreen: true, // Fullscreen mode
            modal: true, // Modal window
            position: 'center', // Centered position
            head: {
                view: 'toolbar', // Toolbar component
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Localized label for the toolbar
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the window
                        },
                    },
                ],
            },
            body: {
                view: 'form',
                id: 'myForm2', // Form component
                type: 'clean', // Clean type
                rows: [
                    accordion_section3,
                    buttons2, // Rows in the form
                ],
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });

        /**
         * Returns the configuration object for the main form.
         * @returns {Object} The configuration object for the main form.
         */
        return {
            id: 'myForm', // Unique identifier for the form
            view: 'form', // Form component
            type: 'clean', // Clean type
            rows: [
                screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }, // Conditional rendering based on screen size
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide the date picker
                $$('Datepicker').show(); // Show the date range picker
            } else {
                $$('Date').show(); // Show the date picker
                $$('Datepicker').hide(); // Hide the date range picker
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get the current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set the date modal based on the language
        });
    }
}

// FILE DOCUMENTED
